import { Button, ButtonProps, styled } from "@mui/material";
import { FC } from "react";
import { COLORS } from "../../constants/colors";

interface StyledButtonProps extends ButtonProps {
  secondary?: boolean;
}

const getButtonColor = ({ secondary }: StyledButtonProps) =>
  secondary ? COLORS.BUTTON_SECONDARY : COLORS.PRIMARY;

const getButtonHoverColor = ({ secondary }: StyledButtonProps) =>
  secondary ? COLORS.TEXT_DISABLED : COLORS.PRIMARY_HOVER;

const SButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "secondary",
})<{ secondary?: boolean }>`
  min-width: 120px;
  text-transform: none;

  &.MuiButton-outlined {
    color: ${getButtonColor};
    border-color: ${getButtonColor};
  }
  &.MuiButton-contained {
    background-color: ${getButtonColor};
    &:hover {
      background-color: ${getButtonHoverColor};
    }
  }
`;

const StyledButton: FC<StyledButtonProps> = ({ secondary, ...rest }) => (
  <SButton secondary={secondary} {...rest} />
);

export { StyledButton };
